import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import { SecondaryBtn } from "./components"
import Main from "./main"

const Wishlist = ({ count, loggedIn }) => (
  <Box contain my={{ _: 4, tablet: 8 }} px={2}>
    <Main />
    <Box my={6} textAlign="center" width="100%">
      <SecondaryBtn
        forwardedAs={Link}
        to={loggedIn || count === 0 ? "/best-sellers" : "/signin"}
      >
        {loggedIn || count === 0
          ? "Shop Best Sellers"
          : "Sign In/Create Your Account"}
      </SecondaryBtn>
    </Box>
  </Box>
)

Wishlist.propTypes = {
  count: PropTypes.number,
  loggedIn: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    count: state.wishlist.count,
    loggedIn: Object.keys(state.user.jewlrorders).length > 0,
  }
}

export default connect(mapStateToProps)(Wishlist)
